import React from "react";

import { Box } from "@mui/material";

const MicLevelBars = ({
  level = 0,
  active = false,
}) => {
  const maxHeights = [
    8,
    13,
    20,
    28,
    20,
    13,
    8,
  ];

  const normalizedLevel =
    Number.isFinite(level)
      ? level
      : 0;

  const boosted = Math.min(
    1,
    (normalizedLevel / 255) * 5,
  );

  return (
    <Box
      display="flex"
      alignItems="flex-end"
      gap="3px"
      height={30}
    >
      {maxHeights.map(
        (maximumHeight, index) => (
          <Box
            key={index}
            sx={{
              width: 5,

              height: active
                ? Math.max(
                    4,
                    boosted *
                      maximumHeight,
                  )
                : 3,

              borderRadius: "2px",

              bgcolor: active
                ? "secondary.main"
                : "grey.300",

              transition:
                "height 0.07s ease, background-color 0.3s",
            }}
          />
        ),
      )}
    </Box>
  );
};

export default MicLevelBars;